export default __webpack_public_path__ + "static/media/tripadvisor.27c5efb1.svg";